import { Row, Col, Popconfirm } from "antd";
import React from "react";
import CleanButton from "../../../common/components/CleanButton";
import Page from "../../../common/components/Page";
import useEFilePayment from "./useEFilePayment";
import useEFile from "../useEFile";
import PaymentForm from "../../payment/paymentForm";
import getConfigs from "../../../GetConfigs";
import Typography from "antd/lib/typography/Typography";

const EFilePayment = ({ ...props }) => {
  const { Title, Content } = Page;
  const { feeDue, setIsModalVisible } = props;
  const { handleMakePayment, paymentTokenLoading, handleContinue } = useEFilePayment();
  const { submitEFileRequest } = useEFile();

  const configurations = getConfigs([
      "activePayProcessor",
      "ctTRCREFilePaymentDisclaimerTxt"
  ]);
  return (
    <Page>
      <div style={{ position: "relative" }} >
      <Title hideBreadcrumb={true} title="Make E-File Payment" icon="money-check-alt" />
              <Content>
          <Row gutter={16}>
          {configurations.ctTRCREFilePaymentDisclaimerTxt && (
            <Col>
                <div dangerouslySetInnerHTML={{ __html: configurations.ctTRCREFilePaymentDisclaimerTxt }} />
            </Col>)}
          <Col>
            <h2>A fee of ${Number(feeDue)?.toFixed(2)} is required for this E-File. Press "Pay" to submit.</h2>
            {feeDue && configurations.activePayProcessor == "authorize" && <PaymentForm amount={feeDue} isModal={true} />}
            {configurations.activePayProcessor != "authorize" && (
              <CleanButton isLoading={paymentTokenLoading} icon="check-double" onClick={() => handleContinue(feeDue)}>
                Pay and Submit E-File
              </CleanButton>
            )}
          </Col>
          <Col>
            <CleanButton onClick={() => setIsModalVisible(false)} icon="times">
              Cancel
            </CleanButton>
          </Col>
        </Row>
        </Content>
      </div>
    </Page>
  );
};

export default EFilePayment;
